import React from 'react';
import './LiveUpdates.css';
import socketIOClient from "socket.io-client";
import SmallHeader from './SmallHeader';
import Timestamp from './Timestamp';
import TrackIcons from './TrackIcons';
import FlipMove from 'react-flip-move';
import { sortByLiveRank } from './liveRanking';

class LiveUpdates extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var compact = this.props.compact;   // enkel de /positions-app-view; /live blijft origineel

    // Voorlopige rang per speler (op tijd + voortgang). De WEERGAVE-volgorde van de
    // lijst blijft ongemoeid — we vullen enkel het rangnummer in.
    var rankById = {};
    sortByLiveRank(this.props.players).forEach((p, idx) => { rankById[p.id] = idx + 1; });

    var players = this.props.players.slice(0, 100); // max 100 renderen

    var renderedPlayers = players.map((player) => {
      const hasPenalty = !!player.penaltyTime && player.penaltyTime > 0;

      // compacte (telefoon-)rij: smalle em-kolommen, flexende naam + voorlopige rang
      if (compact) {
        return (
          <div key={player.id} className="player">
            <div className="lu-cell lu-bib">{player.bib}</div>
            <div className="lu-cell lu-wave">{player.wave}</div>
            <div className="lu-cell lu-cat">{player.category}</div>
            <div className="lu-cell lu-name">{player.name}</div>
            <div className="lu-cell lu-parcours icons"><TrackIcons icons={player.trackParts} /></div>
            <div className={`lu-cell lu-time time-cell ${hasPenalty ? 'penalty' : ''}`}>
              <Timestamp time={player.time + (player.penaltyTime || 0)} />
              {hasPenalty && <span className="penalty-badge">+{Math.floor(player.penaltyTime / 60 / 1000)}:00</span>}
            </div>
            <div className="lu-cell lu-rank">{rankById[player.id]}</div>
          </div>
        );
      }

      // grote-scherm rij (originele bootstrap-layout) + voorlopige rang als laatste kolom
      return (
        <div key={player.id} className="row player">
          <div className="col-1">{player.bib}</div>
          <div className="col-1">{player.wave}</div>
          <div className="col-1">{player.category}</div>
          <div className="col-3 text-truncate">{player.name}</div>
          <div className="col-3 icons"><TrackIcons icons={player.trackParts} /></div>
          <div className={`col-2 text-truncate ${hasPenalty ? 'penalty' : ''}`}>
            <Timestamp time={player.time + (player.penaltyTime || 0)} />
            {hasPenalty && <span className="penalty-badge">+{Math.floor(player.penaltyTime / 60 / 1000)}:00</span>}
          </div>
          <div className="col-1 live-rank">{rankById[player.id]}</div>
        </div>
      );
    });

    return (
      <div className={compact ? 'LiveUpdates compact' : 'LiveUpdates'}>
        <SmallHeader title={this.props.title} />
        <div className="scoreboard">
          {compact ? (
            <div className="scoreboardheader">
              <div className="lu-cell lu-bib">Bib</div>
              <div className="lu-cell lu-wave">Wave</div>
              <div className="lu-cell lu-cat">Cat.</div>
              <div className="lu-cell lu-name">Naam</div>
              <div className="lu-cell lu-parcours">Parcours</div>
              <div className="lu-cell lu-time">{this.props.timeTitle}</div>
              <div className="lu-cell lu-rank">#</div>
            </div>
          ) : (
            <div className="row scoreboardheader">
              <div className="col-1">Bib</div>
              <div className="col-1">Wave</div>
              <div className="col-1">Cat.</div>
              <div className="col-3 text-truncate">Naam</div>
              <div className="col-3 icons">Parcours</div>
              <div className="col-2">{this.props.timeTitle}</div>
              <div className="col-1 live-rank">#</div>
            </div>
          )}
          <FlipMove>
            { renderedPlayers }
          </FlipMove>
        </div>
      </div>
    );
  }
}

export default LiveUpdates;
